import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useParams } from "react-router-dom";

const ExportTE = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Export TnE"));
  }, []);

  const [exportData, setExportData] = useState([]);  
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Name: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    SuperiorName: { text: "Manager", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    AdvanceAmountUSD: { text: "Advance Amt. (USD)", align: "end", visible: true },
    AdvanceAmountINR: { text: "Advance Amt. (INR)", align: "end", visible: true },
    AdvanceAmountBASE: {text: "Advance Base Amt. (INR)",align: "end",visible: true},
    RecieptNo: {text: "Receipt No.",visible: true},
    OnDate:{text:"Date",align:"Center", visible: true},
    Category:{text:"Category", visible: true},
    Subcategory:{text:"Description", visible: true},
    AmountUSD : { text: "Amt.(USD)", align: "end", visible: true },
    AmountINR: { text: "Amt.(INR)", align: "end", visible: true },
    Status: { text: "Status", visible: true },
    VerificationRemark: { text: "Verification Remark", visible: true },
    ApprovedAmountBASE: { text: "Approved Amt. (INR)",align:"end", visible: true },
    BalanceAmountBASE:  { text: "Balance Amt. (INR)",align:"end", visible: true },
    IsDeductFromSalary : { text:"Deduct From Salary",align:"center", visible:true},
    Remark: { text:"Remark", visible:true},
    PayrollMonth: { text: "Payroll Month",align:"center",  visible: true },
  };

  const fetchExportTnE = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/get-export-t&e-list/${id}`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const Data = response?.data?.data;
        setExportData(Data);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

    useEffect(() => {
      if (id) {
        fetchExportTnE(id);
      }
    }, []);


  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={exportData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExportTE;
